var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7c4dff",
    d: "M256 32L32 192v32h448v-32L256 32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9575cd",
    d: "M76 224h360v256H76z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7c4dff",
    d: "M256 224l-60 256h120z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b39ddb",
    d: "M130 224h40v256h-40zM342 224h40v256h-40z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#512da8",
    d: "M32 192l224-160 224 160H32z",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e3b2ff521d77a901cb7260db0851a9a4.svg";
export { ForwardRef as ReactComponent };